export const sliceString = (text: string, sliceLength: number) =>
  text.length > sliceLength ? text.slice(0, sliceLength) + "..." : text;

export const numberWithCommas = (x: number) => {
  let parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return parts.join(".");
};
